import React from 'react';
import type { SimpleBlogItem } from '../utils/BlogListProvider';
import LOGO_PLACEHOLDER from '../assets/images/icons8-blog-150.png';


export interface BlogEntriesListProps {
    blogEntries: SimpleBlogItem[];
}

function BlogEntriesList({ blogEntries }: BlogEntriesListProps) {
    return (
        <div className="row gy-4">
            {blogEntries.map((item, index) => (
                <div
                    key={item.id}
                    className="col-lg-6 aos-init aos-animate"
                    data-aos="fade-up"
                    data-aos-delay={String((index + 1) * 100)}
                >
                    <div className="blog-list d-flex align-items-start">
                        <div className="pic">
                            <img
                                src={item.logoUrl?.trim() || LOGO_PLACEHOLDER}
                                className="img-fluid"
                                alt={item.title}
                            />
                        </div>
                        <div className="member-info">
                            <h4>{item.title}</h4>
                            <span>
                                {[item.contactName, item.city, item.country]
                                    .filter(Boolean)
                                    .join(' · ')}
                            </span>
                            <p>{item.description}</p>
                            <div className="social">
                                {item.blogUrl && (
                                    <a
                                        href={item.blogUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        title="Blog besuchen"
                                        aria-label="Blog"
                                    >
                                        <i className="bi bi-newspaper"></i>
                                    </a>
                                )}
                                {item.ownerEMailAddress && (
                                    <a
                                        href={`mailto:${item.ownerEMailAddress}`}
                                        title="E-Mail"
                                        aria-label="E-Mail"
                                    >
                                        <i className="bi bi-envelope"></i>
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default BlogEntriesList;
